<template>
	<div class="
					is-flex
					is-flex-direction-row
					is-flex-direction-row
					is-flex-align-items-center
				" style="width: 100%" :class="topBarClass">
		<template v-if="isInModule">
			<template v-if="!isMobileViewport">
				<user-header style="width: 25%" class="above-sidebar" />
				<client-header style="width: 75%" />
			</template>
			<template v-else>
				<template v-if="isSidePanelOpen">
					<user-header style="width: 100%" />
				</template>
				<template v-else>
					<client-header style="width: 100%" />
				</template>
			</template>
		</template>
		<template v-else>
			<root-user-header style="width: 100%" />
		</template>
		<session-countdown />
		<version-modal v-model="isVersionModalActive"></version-modal>
		<session-invalid-modal v-model="isSessionInvalidModalActive"></session-invalid-modal>
	</div>
</template>

<script>
/**
 * TopBar component of the applciation displaying the user and the focused client.
 * @displayName TopBar
 */

import UserHeader from "./UserHeader";
import RootUserHeader from "./RootUserHeader";
import ClientHeader from "./ClientHeader";
import { mapGetters } from "vuex";
import Parse from "parse/dist/parse.min.js";
import { version } from "../../../../package.json"
import { isTestSystem } from "@/lib/isTestSystem";
import VersionModal from "../../modals/VersionModal.vue";
import SessionInvalidModal from "../../modals/SessionInvalidModal.vue";
import SessionCountdown from "./SessionCountdown.vue";
import { reloadForNewVersion, clearVersionReloadMark } from "@/lib/versionReload";

export default {
	name: "TopBar",
	data() {
		return {
			applicationVersion: version,
			isVersionModalActive: false,
			isSessionInvalidModalActive: false,
			hasNoConnection: false,
			statusIntervalId: undefined
		};
	},
	async mounted() {
		this.checkServerStatus();
		document.addEventListener('visibilitychange', this.handleVisibilityChange);
		this.statusIntervalId = setInterval(this.checkServerStatus, 10000);
	},
	beforeDestroy() {
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);
		this.stopPolling();
	},
	computed: {
		...mapGetters({
			isMobileViewport: "isMobile",
			apiVersion: "versions/getApiVersion"
		}),
		isInModule() {
			return (
				this.$route.name !== "Root" &&
				this.$route.name !== "Login" &&
				this.$route.name !== "Profile" &&
				this.$route.name !== "NewWidget"
			);
		},
		isSidePanelOpen() {
			return this.$store.state.sidePanelOpen;
		},
		topBarClass() {
			if (this.hasNoConnection) { return "is-not-online"; }
			if (isTestSystem()) { return "is-testsystem"; }
			return "has-darker-grey-color";
		},
	},
	watch: {
		focusedClient() {
			this.checkServerStatus()
		},
	},
	methods: {
		stopPolling() {
			if (this.statusIntervalId === undefined) { return }
			clearInterval(this.statusIntervalId);
			this.statusIntervalId = undefined;
		},
		async checkServerStatus() {
			if (document.hidden) { return }
			let parseServerStatus = Parse.getServerHealth()
			let timeoutID = setTimeout(function () { this.hasNoConnection = true }.bind(this), 3000)
			parseServerStatus.then(value => {
				this.checkVersion();
				this.hasNoConnection = false;
				clearTimeout(timeoutID);
			})
			parseServerStatus.catch(error => {
				this.hasNoConnection = true
				clearTimeout(timeoutID);
			})
		},
		async checkVersion() {
			Parse.Cloud.run("getDiaryVersion").then(async (apiVersion) => {
				this.$store.dispatch("versions/setApiVersion", apiVersion);
				this.isSessionInvalidModalActive = false;
				if (apiVersion != this.applicationVersion) {
					this.isVersionModalActive = !(await reloadForNewVersion());
				}
				else {
					clearVersionReloadMark();
					this.isVersionModalActive = false;
				}
			}).catch((err) => {
				// An expired session cannot recover on its own, stop asking.
				// Other errors (a network blip) must NOT close the modal,
				// only a successful call above may do that.
				if (err.code == Parse.Error.INVALID_SESSION_TOKEN) {
					this.stopPolling();
					this.isSessionInvalidModalActive = true;
				}
			});

		},
		handleVisibilityChange() {
			if (!document.hidden) {
				let parseServerStatus = Parse.getServerHealth()
				let timeoutID = setTimeout(function () { this.hasNoConnection = true }.bind(this), 3000)
				parseServerStatus.then(value => {
					this.hasNoConnection = false
					clearTimeout(timeoutID);
					if (this.apiVersion != this.applicationVersion) {
						this.isVersionModalActive = true
					} else {
						this.isVersionModalActive = false
					}
				})
				parseServerStatus.catch(error => {
					this.hasNoConnection = true
					clearTimeout(timeoutID);
				})
			}
		}
	},
	components: { ClientHeader, UserHeader, RootUserHeader, VersionModal, SessionInvalidModal, SessionCountdown },
};
</script>

<style scoped>
.above-sidebar {
	border-right: 2px solid rgba(255, 255, 255, 0.2);
}
</style>